module.exports = __webpack_public_path__ + "static/media/glassbotpro-1.39ae45a9.jpg";